import axios from 'axios/index';

export const GET_SEKOLAH = '[SEKOLAH] GET SEKOLAH';
export const GET_SEKOLAH_BINAAN = '[SEKOLAH] GET SEKOLAH BINAAN';

export function getSekolah(routeParams)
{
    let paramSekolahId = '';
    if(routeParams.sekolah_id !== null){
        paramSekolahId = '/'+routeParams.sekolah_id
    }

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/Sekolah'+paramSekolahId, {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_SEKOLAH,
                payload: response.data,
                routeParams
            })
        });
}

export function getSekolahBinaan(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.get(baseUrl + '/api/SekolahBinaan', {
        params: routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_SEKOLAH_BINAAN,
                payload: response.data,
                routeParams
            })
        });
}


// WEBPACK FOOTER //
// ./src/store/actions/Sekolah.actions.js